import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect, useRef, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { JVInput } from "../../shared/JVInput";
import { JVCheckbox } from "../../shared/JVCheckbox";
import { EmptyEmailTemplate } from "./EmptyEmailTemplate";
import { JVSunEditor } from "../../shared/JVSuneditor";
import { Toast } from "primereact/toast";
import { IEmailTemplate } from "../../models/BaseModel";
import { JVDropdown } from "../../shared/JVDropdown";

const schema = yup.object({
    templateName: yup.string().required("Template Name is required*"),
    templateSubject: yup.string().required("Template Subject is required*"),
    templateBody: yup.string()
});

interface Iprops {
    singleData: IEmailTemplate,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reloadData: () => void,
    hasPermission: (pageName: string, featureName?: string) => boolean
}

export const Form = (props: Iprops) => {
    const [tbody, settbody] = useState("");
    const [loading, setLoading] = useState(false);
    const toast = useRef<any>(null);

    const { control, handleSubmit, formState: { errors }, reset } = useForm<IEmailTemplate>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false
    });

      const EmailCategory = [
        { name: 'Greeting' },
        { name: 'Notification' },
        { name: 'Festival' },
        { name: 'Offers' },
        { name: 'Discount' },
        { name: 'Special Discount' },
        { name: 'Promotional Offer' },
        { name: 'Mass Mailing' },
        { name: 'Subscribe' },
    ]
    const loadTemplate = async () => {
        setLoading(true);
        const response = await Fetch("Email_Template", "GET", null, null, toast);
        if (response) {
            const data: IEmailTemplate = await response.json();
            if (data.templateBody) settbody(data.templateBody);
            setLoading(false);
        } else setLoading(false);
    }

    useEffect(() => {
        loadTemplate();
        reset(props.singleData);
        if (props.singleData.templateBody)
            settbody(props.singleData.templateBody);
    }, [props.singleData])

    const saveToDB = async (body: IEmailTemplate) => {
        body.templateBody = tbody;
        const method = props.singleData.id ? "PUT" : "POST";
        const message = props.singleData.id ? "Updated Successfully" : "Added Successfully";
        const response = await Fetch("Email_Template", method, body, null, props.toast);

        if (response) {
            props.hideDialog();
            props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
            props.reloadData();
        }
    }
    const onHide = () => {
        props.hideDialog();
        reset(EmptyEmailTemplate);
    }
    function onSubmit(data: IEmailTemplate) {
        if (tbody.length < 1) toast.current.show({ severity: 'error', detail: "Template Body is Required.", life: 3000 });
        else saveToDB(data);
    }
    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Add Template" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <JVDropdown column={2} label="Category" control={control} options={EmailCategory} optionLabel="name" optionValue="name" name="emailCategory" placeholder="Select Email Category" />
                <JVInput  label="Template Name " control={control} name="templateName" error={errors.templateName?.message} />
                <JVInput column={1}  label="Template Subject " control={control} name="templateSubject" error={errors.templateSubject?.message} />
                <div className="col-12 md:col-12 md:col-6 mb-3">
                    <label htmlFor="tbody">Template Body</label>
                    <JVSunEditor name="templateBody" value={tbody} handleChange={settbody} />
                </div>
                {/* <div className="col-12 md:col-12">
                    <Button className="field col-12 md:col-6" label="SAVE" type="submit"></Button>
                    <Button className="field col-12 md:col-6 p-button-outlined" label="CLOSE" onClick={onHide} type="button"></Button>
                </div> */}
                <div className="col-12 md:col-12 flex gap-4 justify-content-end">
                    <Button style={{ width: '100px' }} label="SAVE" type="submit"></Button>
                    <Button style={{ width: '100px' }} label="CLOSE" onClick={onHide} type="button" className="p-button-outlined surface-200"></Button>
                </div>
            </form>
            <Toast ref={toast} />
        </Dialog>
    );
}
